<div class="component-wrapper">
  <lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="header-details-wrapper" [class.no-detail]="!shouldShowDetailView">
        @if (shouldShowDetailView) {
          <div class="details-brief">
            <div class="name-description-container">
              @if (schedule?.name) {
                <div class="detail-container">
                  <h5>Name</h5>
                  <div class="detail-item" [titleIfTruncated]="schedule?.name" [maxLength]="30">{{
                    schedule?.name | formatNameLength : 30
                  }}</div>
                </div>
              }
              @if (schedule?.description) {
                <div class="detail-container">
                  <h5>Description</h5>
                  <div class="detail-item">{{ schedule?.description }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (shouldShowDetailView) {
          <div class="right context-actions">
            <button
              type="button"
              mat-button
              [matMenuTriggerFor]="updateDetailsMenu"
              matTooltip="Info"
              aria-label="Schedule Info"
              id="schedule-detail-info"
              >
              <mat-icon>info</mat-icon>
            </button>
            @if (canDelete()) {
              <button
                type="button"
                mat-button
                [matMenuTriggerFor]="scheduleMenu"
                aria-label="Schedule Actions"
                matTooltip="More Actions"
                id="schedule-detail-more-actions"
                >
                <mat-icon>more_horiz</mat-icon>
              </button>
            }
          </div>
        }
      </div>
      <div class="detail-content">
        <ndt-two-column-layout>
          <div ndtRightColumn>
            @if (!shouldShowDetailView) {
              <div class="align-to-center"> No existing schedules. </div>
            }
            @if (shouldShowDetailView) {
              <mat-tab-group>
                <mat-tab label="General">
                  <div class="mat-tab-indented">
                    <div class="fields-container">
                      <mat-form-field class="flex-half">
                        <mat-label>Name</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          [value]="schedule?.name"
                          formControlName="name"
                          id="name"
                          required
                          />
                          @if (form.get('name')?.hasError('required')) {
                            <mat-error>
                              Name is Required.
                            </mat-error>
                          }
                          @if (
                            !form.get('name')?.hasError('required') && form.get('name')?.hasError('pattern')
                            ) {
                            <mat-error
                              >
                              Invalid Name. Name may include letters, numbers, and characters. No leading/trailing
                              spaces.
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="flex-half">
                          <mat-label>Description</mat-label>
                          <input
                            matInput
                            autocomplete="off"
                            type="text"
                            [value]="schedule?.description"
                            formControlName="description"
                            id="description"
                            />
                            @if (form.get('description')?.hasError('pattern')) {
                              <mat-error>
                                Invalid Description. Description may include letters, numbers, and characters. No
                                leading/trailing spaces.
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <th class="table-descriptor">
                          <span>Phone numbers using this schedule</span>
                        </th>
                        <mat-divider class="schedule-phone-numbers-divider"></mat-divider>
                        @if (!schedule?.phoneNumbersConnection?.items?.length) {
                          <div>
                            No phone numbers currently associated with schedule.
                          </div>
                        }
                        @if (schedule?.phoneNumbersConnection?.items?.length > 0) {
                          <lcs-responsive-table
                            [columns]="columns"
                            >
                            <table #table lcs-table [dataSource]="schedule?.phoneNumbersConnection?.items">
                              <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
                              <tr lcs-row *lcsResponsiveRowDef></tr>
                              <ng-container lcsColumnDef="phoneNumber" width="4">
                                <th lcs-header-cell *lcsHeaderCellDef id="phoneNumber-column-header"
                                  >Phone Number:</th
                                  >
                                  <td
                                    lcs-cell
                                    *lcsCellDef="let phoneNumber"
                                    [routerLink]="getRouterLink(phoneNumber.phoneNumberId)"
                                    >
                                    <a>
                                      {{ phoneNumber.phoneNumber | formatPhoneNumbers }}
                                    </a>
                                  </td>
                                </ng-container>
                                <ng-container lcsColumnDef="displayName" width="4">
                                  <th lcs-header-cell *lcsHeaderCellDef id="display-name-column-header"
                                    >Display Name:</th
                                    >
                                    <td
                                      lcs-cell
                                      *lcsCellDef="let phoneNumber"
                                      [routerLink]="getRouterLink(phoneNumber.phoneNumberId)"
                                      >
                                      <a>
                                        {{ phoneNumber.displayName }}
                                      </a>
                                    </td>
                                  </ng-container>
                                  <ng-container lcsColumnDef="status" width="2">
                                    <th lcs-header-cell *lcsHeaderCellDef id="status-column-header">Status:</th>
                                    <td
                                      lcs-cell
                                      *lcsCellDef="let phoneNumber"
                                      [routerLink]="getRouterLink(phoneNumber.phoneNumberId)"
                                      >
                                      <a>
                                        {{ phoneNumber.phoneNumberStatus ? 'Open' : 'Closed' }}
                                      </a>
                                    </td>
                                  </ng-container>
                                </table>
                              </lcs-responsive-table>
                            }
                          </div>
                        </mat-tab>
                        <mat-tab label="Schedule">
                          <div class="mat-tab-indented">
                            <ndt-schedule-hours
                              [callState]="callState"
                              [canEdit]="schedulePrivileges.canEdit"
                              [canDelete]="schedulePrivileges.canDelete"
                              formControlName="scheduleHours"
                              (addScheduleHourClick)="onAddScheduleHourClick()"
                            ></ndt-schedule-hours>
                          </div>
                        </mat-tab>
                        <mat-tab label="Closed Exceptions">
                          <div class="mat-tab-indented">
                            <ndt-closed-exceptions
                              [callState]="callState"
                              [accountId]="schedule?.accountId"
                              [canEdit]="schedulePrivileges.canEdit"
                              [canDelete]="schedulePrivileges.canDelete"
                              formControlName="closedExceptions"
                              [scheduleId]="schedule?.scheduleId"
                              (addClosedExceptionClick)="onAddClosedExceptionClick()"
                            ></ndt-closed-exceptions>
                          </div>
                        </mat-tab>
                      </mat-tab-group>
                    }
                  </div>
                  <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
                </ndt-two-column-layout>
              </div>
            </form>
          </lcs-loading-overlay>
          <mat-menu #scheduleMenu="matMenu">
            @if (canDelete()) {
              <button mat-menu-item type="button" (click)="onDeleteClick()" id="schedule-delete">
                Delete
              </button>
            }
          </mat-menu>
          <mat-menu #updateDetailsMenu="matMenu">
            <update-details
              [createUser]="schedule?.createUser"
              [createDate]="schedule?.createDate"
              [updateUser]="schedule?.updateUser"
              [updateDate]="schedule?.updateDate"
            ></update-details>
          </mat-menu>
        </div>
